import { useEffect, useRef } from 'react'
import type { LevelUpEvent } from '../hooks/useLeveleria'
import { SparkIcon } from './Icons'
import { useI18n } from '../../i18n'

interface LevelUpDialogProps {
  event: LevelUpEvent | null
  onClose: () => void
}

export const LevelUpDialog = ({ event, onClose }: LevelUpDialogProps) => {
  const { copy: { common, levelUp } } = useI18n()
  const dialogRef = useRef<HTMLDialogElement>(null)

  useEffect(() => {
    const dialog = dialogRef.current
    if (event && dialog && !dialog.open) dialog.showModal()
    if (!event && dialog?.open) dialog.close()
  }, [event])

  if (!event) return null

  return (
    <dialog ref={dialogRef} className="level-up-dialog" onCancel={(e) => { e.preventDefault(); onClose() }} onClose={onClose}>
      <SparkIcon style={{ color: event.areaColor }} />
      <p>{levelUp.title}</p>
      <h2>{event.areaName}</h2>
      <strong style={{ color: event.areaColor }}>{common.level.toLocaleUpperCase()} {event.oldLevel} → {event.newLevel}</strong>
      <button className="button button--primary" type="button" onClick={onClose}>{levelUp.continue}</button>
    </dialog>
  )
}
